import { useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import Header from './Header'
import Footer from './Footer'
import PodcastPlayer from './PodcastPlayer'
import ToastContainer from './ToastContainer'

function PageLayout({ children, showHeader = true, showFooter = true }) {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col">
      {showHeader && <Header />}
      <main className="flex-1">
        {children}
      </main>
      {showFooter && <Footer />}
      <PodcastPlayer />
      <ToastContainer />
    </div>
  );
}

export default PageLayout;